module.exports = __webpack_public_path__ + "img/photo.7cb9550d.jpg";